export const BaseAPIUrl = '{BaseAPIUrl}';
export const FulfillmentId = '{FulfillmentId}';
export const PostCode = '{postCode}';
export const DefaultWarehouse = '{defaultWarehouse}';
export const cmsContentType = 'fulfillment_types';
export const cmsAPIVersion = 'v1';
export const FeeId = '{FeeId}';
export const ServiceLocationId = '{ServiceLocationId}';
